import { legacyToBookingsSettings } from '../businessInfo/legacyToSettingsBusinessInfo';
import { legacyToSettingsFeatures } from '../activeFeature/legacyToSettingsFeatures';
import { BasedOn } from '@wix/ambassador-bookings-v2-bookings-settings/types';
import { BusinessPropertyName, isPropertyEnabled } from '../businessInfo/businessInfo';
export const legacyToSettingsResponse = legacy => {
  var _legacy$customPropert;
  const info = legacy.infoView;
  const isMultiServiceAppointmentsEnabled = isPropertyEnabled(legacy, BusinessPropertyName.MULTI_SERVICES_APPOINTMENTS);
  const isCartEnabled = isPropertyEnabled(legacy, BusinessPropertyName.IS_CART_ENABLED);
  const isClientCanChangeTimezone = isPropertyEnabled(legacy, BusinessPropertyName.CLIENT_CAN_CHANGE_TIMEZONE);
  const isBusinessIsDefaultTimeZone = isPropertyEnabled(legacy, BusinessPropertyName.DEFAULT_TIMEZONE);
  const bookingsSettings = {
    siteProperties: legacyToBookingsSettings(legacy),
    features: legacyToSettingsFeatures(legacy.activeFeatures),
    extendedFields: {
      customProperties: [...(((_legacy$customPropert = legacy.customProperties) == null ? void 0 : _legacy$customPropert.map(prop => ({
        namespaces: {
          [prop.propertyName ?? '']: prop.value ?? ''
        }
      }))) ?? []), {
        namespaces: {
          ...(info != null && info.businessType ? {
            ['business type']: [info == null ? void 0 : info.businessType]
          } : {}),
          ...(info != null && info.premiumInfo ? {
            ['premium info']: [info == null ? void 0 : info.premiumInfo]
          } : {})
        }
      }]
    },
    cartCheckout: isCartEnabled ? {
      enabled: true
    } : undefined,
    multiServiceAppointments: isMultiServiceAppointmentsEnabled ? {
      enabled: true
    } : undefined,
    displayTimeZone: {
      customerCanChange: isClientCanChangeTimezone,
      basedOn: isBusinessIsDefaultTimeZone ? BasedOn.BUSINESS_TIME_ZONE : BasedOn.CUSTOMER_TIME_ZONE
    }
  };
  return {
    bookingsSettings
  };
};
//# sourceMappingURL=legacyToSettingsResponse.js.map